import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5cb2c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_choose_product",
  ref: "chooseProduct",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_choose_product_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { style: {"min-height":"100px"} }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group d-flex flex-wrap" }
const _hoisted_14 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group d-flex flex-wrap" }
const _hoisted_17 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_18 = { class: "modal-footer flex-right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "indicator-label" }
const _hoisted_22 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_23 = { class: "indicator-progress" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipments.selectProducts")), 1),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args))),
              class: "btn btn-icon btn-sm btn-active-icon-primary"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_table, {
                      class: "mb-7",
                      ref: "multipleTableRef",
                      data: _ctx.options.list,
                      style: {"width":"100%"},
                      height: "400",
                      onSelectionChange: _ctx.handleSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "selection",
                          width: "50"
                        }),
                        _createVNode(_component_el_table_column, {
                          property: "id",
                          label: _ctx.t('order.skuIdentifier'),
                          width: "140"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.image'),
                          width: "150"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_el_carousel, {
                                "indicator-position": "none",
                                height: "100px",
                                autoplay: false,
                                arrow: "never"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.gallery, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                      key: index,
                                      class: "d-flex justify-content-center align-items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_image, {
                                          style: {"width":"100px","height":"100px","cursor":"pointer"},
                                          src: item.origin_url,
                                          fit: "contain",
                                          onClick: ($event: any) => (_ctx.previewImages(row.gallery, index))
                                        }, null, 8, ["src", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.articleInformation'),
                          width: "220"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("p", null, _toDisplayString(row.name_en), 1),
                            _createElementVNode("p", null, _toDisplayString(row.name), 1),
                            _createElementVNode("p", null, _toDisplayString(row.__show.brand_id), 1),
                            _createElementVNode("p", null, _toDisplayString(row.brand_article_no), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.articleAttributes'),
                          width: "220"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(row.__show.size), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(row.original_color), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.eanNumber')
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(row.gtin), 1)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data", "onSelectionChange"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")), 1),
                          _createVNode(_component_el_form_item, { prop: "merchant" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.merchant,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                                filterable: "",
                                clearable: "",
                                "remote-show-suffix": "",
                                remote: "",
                                "remote-method": _ctx.searchMerchantSourceItems,
                                onChange: _ctx.merchantChange,
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "remote-method", "onChange", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("fulfillmentOrder.channel")), 1),
                          _createVNode(_component_el_form_item, { prop: "channel" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.channel,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.channel) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                loading: _ctx.options.channelLoading
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "loading"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light me-3",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                  }, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToPrevious")), 1)
                  ]),
                  _createElementVNode("button", {
                    ref: "submitButton",
                    type: "submit",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.isDisabledSubmit
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                    ]),
                    _createElementVNode("span", _hoisted_23, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_24
                    ])
                  ], 8, _hoisted_20)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}